import { render, staticRenderFns } from "./masterdata-silhouette-field.vue?vue&type=template&id=10dcec65&scoped=true&lang=pug"
import script from "./masterdata-silhouette-field.vue?vue&type=script&lang=ts"
export * from "./masterdata-silhouette-field.vue?vue&type=script&lang=ts"
import style0 from "./masterdata-silhouette-field.vue?vue&type=style&index=0&id=10dcec65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dcec65",
  null
  
)

export default component.exports